import { FC } from "react";
import { Card, Col } from "react-bootstrap";
import { DevOrganizationData, Organization } from "../../models/types";
import { useQuery } from "@apollo/client";
import { GET_DEV_ORGANIZATIONS } from "../../graphql/queries";
import { SearchableDropdown } from "../dropdowns/SearchableDropdown";

interface Props {
    organization: Organization | undefined;
    updateOrganization: (selectedOrganization: Organization) => void;
}

export const OrganizationSelectionView: FC<Props> = ({
    organization,
    updateOrganization
}) => {
    const { data: { devOrganizations } = {} } = useQuery<DevOrganizationData>(
        GET_DEV_ORGANIZATIONS
    );

    return (
        <Card className="border-secondary">
            <div className="py-2">
                <Col className="m-0 ps-2 mb-2" md={12}>
                    <h5 className="text-inverse p-2">Organization</h5>
                </Col>
                <Col
                    md={12}
                    className="d-flex justify-content-center align-content-center px-4 mb-3"
                >
                    <SearchableDropdown
                        selectedValue={
                            organization === undefined
                                ? "Select Organization"
                                : organization.name
                        }
                        placeholder="Select Organization"
                        choices={devOrganizations?.map(
                            organization => organization.name
                        )}
                        onSelect={(selectedItem: string | null | undefined) => {
                            if (selectedItem) {
                                const selectedOrganization =
                                    devOrganizations?.find(
                                        element => element.name === selectedItem
                                    );
                                if (selectedOrganization) {
                                    updateOrganization(selectedOrganization);
                                }
                            }
                        }}
                    />
                </Col>
            </div>
        </Card>
    );
};
